// firstname
// lastname
// color
// url
// createdAt
// message

import { Avatar, Button, Popconfirm } from 'antd';

import cls from './Comment.module.scss'
import moment from 'moment';
import { DeleteOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import ImageUrl from '../../../helpers/ImageUrl';

export function Comment ({firstName, lastName, color, url, createdAt, message, onRemove, noBorder}) {
    return (
        <div className={classNames(cls.comment, noBorder && cls.noBorder)}>
            <div className={cls.top}>
                <div className={cls.avatar}>
                    <Avatar size={24} src={ImageUrl(url)} style={!url && {backgroundColor: color}}>
                        {firstName.charAt(0)}{lastName.charAt(0)}
                    </Avatar>
                    {firstName} {lastName}
                </div>
                <div>
                    {moment(createdAt).format('DD MMM YYYY HH:mm')}
                    {onRemove && <Popconfirm
                        title="Удалить сообщение"
                        description="Вы уверены что хотите удалить сообщение?"
                        onConfirm={onRemove}
                        okText="Да"
                        cancelText="Нет"
                    >
                        <Button type={'link'} icon={<DeleteOutlined />}/>
                    </Popconfirm>
                    }
                </div>
            </div>
            <div>{message}</div>
        </div>
    )
}
